import AvailablePlanCard from './AvailablePlanCard';

export default AvailablePlanCard;
